
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { updateCustomerNotificationSettings, getCustomerNotificationSettings } from "../../../Requests/Configuration.js";
import { Cmd_batch, Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { ofArray, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { UpdateCustomerNotificationSettingsDto } from "../../../Shared/NotificationSettings.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";

export function init() {
    return [new State(new RequestedValue$1(0, []), FormState_get_empty()), getCustomerNotificationSettings((Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const changed = msg.fields[0];
            const matchValue = state.Settings;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(new RequestedValue$1(1, [map((setting) => {
                    if (equals(setting.Message, changed.Message) && equals(setting.Channel, changed.Channel)) {
                        return changed;
                    }
                    else {
                        return setting;
                    }
                }, matchValue.fields[0])]), state.FormState), Cmd_none()];
            }
        }
        case 2: {
            const matchValue_1 = state.Settings;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.Settings, FormState__startLoading(state.FormState)), updateCustomerNotificationSettings(new UpdateCustomerNotificationSettingsDto(matchValue_1.fields[0]), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
            }
        }
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Settings, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Settings, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), getCustomerNotificationSettings((Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(4, [Item_3])))]))];
            }
        }
        case 4:
            return [new State(state.Settings, FormState_get_empty()), Cmd_errorToast("general.a_error_occured")];
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0].Settings]), state.FormState), Cmd_none()];
    }
}

